var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "intervention-plan-continer" },
    [
      _c(
        "page-header",
        {
          attrs: {
            actions: _vm.pageHeaderActionsConfig,
            "left-side-class": "col-md-7",
            page: _vm.pageHeaderConfig,
            "right-side-class":
              "col-sm-12 col-md-5 align-items-end d-flex pb-2 justify-content-end"
          }
        },
        [
          _vm.showDropdownActionsButtons
            ? _c("dropdown", {
                staticClass: "actions-dropdown",
                attrs: { items: _vm.dropdownActionItems, title: "Acciones" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.showAbsenceDocumentation
        ? _c("absence-intervention-plan", {
            staticClass: "mb-2",
            attrs: {
              "absence-reasons": _vm.collections.absenceReasons,
              "linked-date": _vm.admissionInfo.linkedDate
            },
            on: {
              "on-cancel": () => (_vm.showAbsenceDocumentation = false),
              "on-save": function($event) {
                return _vm.onSaveAbsenceInterventionHandler($event)
              }
            }
          })
        : _vm._e(),
      _vm.showInvoice && !_vm.isLoadingPlanInfo
        ? _c("invoice-plan", {
            ref: "invoicePlan",
            attrs: {
              "continue-editing": _vm.getInvoiceContinueEditing,
              "has-discussion": _vm.hasPlanDiscussion,
              info: _vm.invoice,
              "intervention-flags": _vm.interventionFlags,
              "is-electronic-signature": _vm.isElectronicSignature,
              "is-intervention-plan-electronic-signed":
                _vm.isInterventionPlanElectronicSigned,
              "is-plan-amendment": _vm.showAmendedPlanHistoryButton,
              "is-sign-hub-active": _vm.isSignHubActive,
              "max-date": _vm.maxDate,
              "only-show-plan": _vm.onlyShowPlan,
              "read-only": _vm.invoiceReadOnly,
              specialists: _vm.collections.writerSpecialists,
              "wrapper-class": "mb-3"
            },
            on: {
              alert: _vm.validationToast,
              "alert-billing-change": _vm.alertBillingChangeHandler,
              cancel: _vm.cancelHandler,
              "delete-discussion": _vm.deleteDiscussionHandler,
              "edit-mode": _vm.editMode,
              "is-plan-billing-change": _vm.isPlanBillingChange,
              "save-info": _vm.invoiceSaveHandler
            }
          })
        : _vm._e(),
      _c("board", { attrs: { details: _vm.invoiceDetailsBoard } }),
      _vm.achievementSummary
        ? _c("execution-level-legend", {
            attrs: {
              "legend-data": _vm.executionLevelArchieved,
              title: "Leyenda de Claves para objetivos de resumen de logros"
            }
          })
        : _vm._e(),
      _c(
        "b-tabs",
        {
          staticClass: "mt-3",
          attrs: { "nav-class": "custom-nav-container", "no-nav-style": true },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c(
            "b-tab",
            {
              attrs: {
                active: true,
                title: _vm.achievementSummary
                  ? "Informe de Logros"
                  : "Plan de Intervención"
              }
            },
            [
              _c(
                "div",
                { staticClass: "mx-2" },
                [
                  _c(
                    "custom-collapse",
                    {
                      staticClass: "intervention-plan-collapse mt-3 px-2",
                      attrs: { id: "ip-collapse" }
                    },
                    [
                      _c(
                        "custom-collapse-item",
                        {
                          attrs: {
                            id: "collapse-item-strength",
                            "body-background-color": "#F7F7F7",
                            checked: _vm.checkedStrengths,
                            expanded: true,
                            "parent-id": "ip-collapse",
                            title: "Información de Fortalezas"
                          }
                        },
                        [
                          _vm.disciplineTypeId > 0
                            ? _c("strengthSelection", {
                                ref: "strengthSelection",
                                attrs: {
                                  "discipline-type-id": _vm.disciplineTypeId,
                                  "read-only": _vm.readOnly,
                                  strengths: _vm.strengths
                                },
                                on: {
                                  "save-strengths": _vm.savestrengthsHandler
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "custom-collapse-item",
                        {
                          attrs: {
                            id: "collapse-item-need",
                            "body-background-color": "#F7F7F7",
                            checked: _vm.checkedNeed,
                            expanded: false,
                            "parent-id": "ip-collapse",
                            title: "Información de Necesidades"
                          }
                        },
                        [
                          _vm.disciplineTypeId > 0
                            ? _c("NeedSelection", {
                                ref: "NeedSelection",
                                attrs: {
                                  "discipline-type-id": _vm.disciplineTypeId,
                                  needs: _vm.needs,
                                  "read-only": _vm.readOnly
                                },
                                on: { "save-needs": _vm.saveNeedsHandler }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "custom-collapse-item",
                        {
                          staticClass: "collapse-item",
                          attrs: {
                            id: "collapse-item-goals",
                            "body-background-color": "#F7F7F7",
                            "button-text":
                              _vm.goals.length != 0 && !_vm.readOnly
                                ? "Añadir Meta"
                                : "",
                            checked: _vm.checkedGoals,
                            expanded: false,
                            "parent-id": "ip-collapse",
                            title: "Información de Metas y Objetivos"
                          },
                          on: {
                            collapseItemButtonClick: function($event) {
                              return _vm.addGoal()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "p-2 mb-2" },
                            [
                              _vm.goals.length == 0 && !_vm.showAddGoal
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bg-white p-3 row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn col-9 col-md-6 bg-light-white py-0 font-weight-normal",
                                          on: {
                                            click: function($event) {
                                              return _vm.addGoal()
                                            }
                                          }
                                        },
                                        [
                                          _c("em", {
                                            staticClass:
                                              "fas fa-file-plus pr-3 text-green"
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              "Presione aquí para añadir meta"
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "validation-observer",
                                    { ref: "interventionPlanGoal" },
                                    [
                                      _vm._l(_vm.goals, function(goal, index) {
                                        return _c(
                                          "div",
                                          { key: `goals-${index}-${goal.id}` },
                                          [
                                            goal.editGoal
                                              ? _c("goal-form", {
                                                  key: `goal-form-${index}`,
                                                  staticClass: "mb-3",
                                                  attrs: {
                                                    "area-options":
                                                      _vm.areaOptions,
                                                    data: goal,
                                                    "goal-options":
                                                      _vm.goalOptions,
                                                    "is-pei-signed":
                                                      _vm.isPeiSigned,
                                                    "show-area-selection":
                                                      _vm.showAreaSelection,
                                                    "student-has-educational-service":
                                                      _vm.studentHasEducationalService
                                                  },
                                                  on: {
                                                    "cancel-update": function(
                                                      $event
                                                    ) {
                                                      return _vm.cancelUpdateHandler(
                                                        index
                                                      )
                                                    },
                                                    "edit-goal": function(
                                                      $event
                                                    ) {
                                                      return _vm.editGoalHandler(
                                                        $event,
                                                        index
                                                      )
                                                    }
                                                  }
                                                })
                                              : _c("intervention-plan-goals", {
                                                  key: `goal-${index}`,
                                                  attrs: {
                                                    "achievement-summary":
                                                      _vm.achievementSummary,
                                                    data: goal,
                                                    "legend-data":
                                                      _vm.executionFormData,
                                                    position: index + 1,
                                                    "read-only": _vm.readOnly,
                                                    "show-area-selection":
                                                      _vm.showAreaSelection,
                                                    "submitted-summaries":
                                                      _vm.submittedSummaries
                                                  },
                                                  on: {
                                                    "delete-goal": function(
                                                      $event
                                                    ) {
                                                      return _vm.deleteGoalHandler(
                                                        index
                                                      )
                                                    },
                                                    "edit-goal": function(
                                                      $event
                                                    ) {
                                                      return _vm.showEditGoalHandler(
                                                        index
                                                      )
                                                    },
                                                    "on-change-data":
                                                      _vm.changeDataHandler
                                                  }
                                                })
                                          ],
                                          1
                                        )
                                      }),
                                      _vm.showAddGoal
                                        ? _c("goal-form", {
                                            attrs: {
                                              "area-options": _vm.areaOptions,
                                              "goal-options": _vm.goalOptions,
                                              "is-pei-signed": _vm.isPeiSigned,
                                              "show-area-selection":
                                                _vm.showAreaSelection,
                                              "student-has-educational-service":
                                                _vm.studentHasEducationalService
                                            },
                                            on: {
                                              "cancel-add":
                                                _vm.cancelGoalHandler,
                                              "save-goal": _vm.saveGoalHandler
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    2
                                  )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "custom-collapse-item",
                        {
                          attrs: {
                            id: "collapse-item-criterion",
                            "body-background-color": "#F7F7F7",
                            checked: _vm.checkedCriteria,
                            expanded: false,
                            "parent-id": "ip-collapse",
                            title: "Criterios y Procedimientos"
                          }
                        },
                        [
                          _c(
                            "validation-observer",
                            { ref: "interventionPlanCriterias" },
                            [
                              _c("intervention-plan-criterias", {
                                attrs: {
                                  data: _vm.criterias,
                                  "read-only": _vm.readOnly
                                },
                                on: {
                                  "cancel-criteria": _vm.cancelCriteriahandler,
                                  "delete-criteria": _vm.deleteCriteriaHandler,
                                  "save-criteria": _vm.saveCriteriaHandler
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "custom-collapse-item",
                        {
                          attrs: {
                            id: "collapse-item-specialist",
                            "body-background-color": "#F7F7F7",
                            checked: _vm.checkedSpecialists,
                            expanded: false,
                            "parent-id": "ip-collapse",
                            title: "Información de Especialista"
                          }
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c(
                                    "validation-provider",
                                    { attrs: { rules: "required" } },
                                    [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: "serviceSpecialist",
                                          disabled: _vm.readOnly,
                                          error: _vm.errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label: "Especialista de Servicio: ",
                                          name: "serviceSpecilist",
                                          options:
                                            _vm.collections.serviceSpecialists
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.getSpecialistInfo()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.specialistInfo
                                              .serviceSpecialist,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.specialistInfo,
                                              "serviceSpecialist",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "specialistInfo.serviceSpecialist"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("hr")
                                ],
                                1
                              )
                            ]),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c(
                                    "validation-provider",
                                    { attrs: { rules: "required" } },
                                    [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: "writerSpecialist",
                                          disabled: _vm.readOnly,
                                          error: _vm.errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label:
                                            "Persona que redactó el plan: ",
                                          name: "writerSpecialist",
                                          options:
                                            _vm.collections.writerSpecialists
                                        },
                                        model: {
                                          value:
                                            _vm.specialistInfo.writerSpecialist,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.specialistInfo,
                                              "writerSpecialist",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "specialistInfo.writerSpecialist"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("hr")
                                ],
                                1
                              )
                            ]),
                            _c("div", { staticClass: "row col-md-12" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "row bg-white w-100 ml-1",
                                  staticStyle: { "min-height": "8vh" }
                                },
                                [
                                  _c("div", { staticClass: "col-md-4 mt-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "color-secondary-6 font-14"
                                      },
                                      [_vm._v(" Especialista de Servicio: ")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-black font-16 font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.specialistInfo
                                                .selectedServiceSpecialist
                                                .fullName
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-md-4 mt-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "color-secondary-6 font-14"
                                      },
                                      [_vm._v(" Numero de Licencia: ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "color-black font-16" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.specialistInfo
                                                .selectedServiceSpecialist
                                                .licenceNo
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("div", { staticClass: "col-md-4 mt-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "color-secondary-6 font-14"
                                      },
                                      [_vm._v(" Fecha de Expiración: ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "color-black font-16" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.specialistInfo
                                                .selectedServiceSpecialist
                                                .expirationDate
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm.canViewDocumentSection
                        ? _c(
                            "custom-collapse-item",
                            {
                              attrs: {
                                id: "collapse-item-document",
                                "body-background-color": "#F7F7F7",
                                checked: _vm.documentSaved,
                                expanded: false,
                                "parent-id": "ip-collapse",
                                title: "Documento"
                              }
                            },
                            [
                              _c(
                                "validation-observer",
                                { ref: "interventionPlanDocument" },
                                [
                                  _c("intervention-plan-document", {
                                    attrs: {
                                      data: _vm.document,
                                      saved: _vm.documentSaved
                                    },
                                    on: {
                                      "cancel-document":
                                        _vm.cancelDocumenthandler,
                                      "edit-document": _vm.editDocumentHandler,
                                      "save-document": _vm.saveDocumentHandler
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.validate
                    ? _c(
                        "div",
                        [
                          _vm.errors.strength.invalid
                            ? _c("custom-error", {
                                attrs: { message: _vm.errors.strength.message }
                              })
                            : _vm._e(),
                          _vm.errors.need.invalid
                            ? _c("custom-error", {
                                attrs: { message: _vm.errors.need.message }
                              })
                            : _vm._e(),
                          _vm.errors.goals.invalid
                            ? _c("custom-error", {
                                attrs: { message: _vm.errors.goals.message }
                              })
                            : _vm._e(),
                          _vm.errors.criteria.invalid
                            ? _c("custom-error", {
                                attrs: { message: _vm.errors.criteria.message }
                              })
                            : _vm._e(),
                          _vm.errors.specialist.invalid
                            ? _c("custom-error", {
                                attrs: {
                                  message: _vm.errors.specialist.message
                                }
                              })
                            : _vm._e(),
                          !_vm.isSignHubActive && _vm.errors.document.invalid
                            ? _c("custom-error", {
                                attrs: { message: _vm.errors.document.message }
                              })
                            : _vm._e(),
                          _vm.summaryErrors().executionLevel.invalid &&
                          _vm.achievementSummary
                            ? _c("custom-error", {
                                attrs: {
                                  message: _vm.summaryErrors().executionLevel
                                    .message
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.achievementSummary
                    ? [
                        _c("achievements-summary", {
                          attrs: {
                            data: _vm.archievements,
                            "is-sign-hub-active": _vm.isSignHubActive,
                            periods: _vm.selectedPeriodsToSubmit,
                            "read-only": _vm.summaryReadOnly,
                            "signature-hub-info": _vm.signatureHubInfo,
                            specialists: _vm.collections.writerSpecialists
                          },
                          on: {
                            alert: _vm.validationToast,
                            "delete-achieve": _vm.deleteGoalsSummaryHandler,
                            "delete-archivement": _vm.deleteArchivement,
                            save: _vm.saveGoalSummaryHandler
                          }
                        }),
                        _vm.summaryErrors().achievement.invalid &&
                        _vm.validate &&
                        !_vm.partialSave
                          ? _c("custom-error", {
                              attrs: {
                                message: _vm.summaryErrors().achievement.message
                              }
                            })
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm.canAddDiagnosisInPilot
            ? _c("b-tab", { attrs: { title: "Diagnóstico" } }, [
                _c(
                  "div",
                  { staticClass: "p-4" },
                  [
                    _vm.disciplineTypeId
                      ? _c("add-diagnosis", {
                          attrs: {
                            "has-cancel": false,
                            "is-read-only": _vm.readOnly,
                            item: _vm.studentPlanInfo
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.canViewSignPlanTab
            ? _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.achievementSummary ? "Firma" : "Firma del Plan"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "my-4" },
                    [
                      _c("sign-plan", {
                        ref: "signPlanRef",
                        attrs: {
                          disabled: _vm.signPlanRefDisabled,
                          "is-electronic-signature": _vm.isElectronicSignature,
                          "question-label": _vm.questionLabel
                        },
                        on: { change: _vm.handleSelectMechanism }
                      }),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _vm.hasSelectMechanismManuscrito
                            ? _c(
                                "div",
                                [
                                  _c("section-title", {
                                    attrs: {
                                      content: "Documento",
                                      "has-line": ""
                                    }
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "bg-secondary-13 rounded p-3"
                                    },
                                    [
                                      _c(
                                        "validation-observer",
                                        {
                                          ref:
                                            "interventionPlanSignatureDocument"
                                        },
                                        [
                                          _c(
                                            "intervention-plan-signature-document",
                                            {
                                              ref:
                                                "interventionPlanSignatureDocumentRef",
                                              attrs: {
                                                data: _vm.document,
                                                "read-only":
                                                  _vm.signatureDocumentReadOnly,
                                                saved: _vm.documentSaved,
                                                title:
                                                  _vm.signatureDocumentTitle
                                              },
                                              on: {
                                                "cancel-document":
                                                  _vm.handleCancelSignatureDocument,
                                                "edit-document":
                                                  _vm.editDocumentHandler,
                                                "save-document": docFile =>
                                                  _vm.saveDocumentHandler(
                                                    docFile,
                                                    false
                                                  )
                                              }
                                            }
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-right mt-3" },
                                    [
                                      _vm.showSaveDocumentButton &&
                                      _vm.hasDocumentFile
                                        ? _c("action-button", {
                                            attrs: {
                                              i: "pr-1 fas fa-save",
                                              text: "Guardar Documento",
                                              variant: "outline-success mx-2"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.achievementSummary &&
                                                _vm.hasSelectMechanismManuscrito
                                                  ? _vm.saveAchievementSummaryDocumentHandler()
                                                  : _vm.saveDocumentPlanHandler()
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.hasSelectMechanismElectronica
                            ? _c("signature-hub-info", {
                                attrs: {
                                  "signature-info": _vm.signatureHubInfo
                                },
                                on: {
                                  "configure-sign":
                                    _vm.handleConfigureSignatures
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }